import emAssistantStoresJsc from "@/store/emAssistant/jsc/moduleIndex-store-emAssistant-jsc";

const entities = {
    ...emAssistantStoresJsc,
}

export default entities
